export function getEmptyStateName(pathname?: string) {
    if (pathname?.includes('/analytics')) {
        return 'analytics';
    }
    if (pathname?.includes('/listening')) {
        return 'listening';
    }
    if (pathname?.includes('/campaigns')) {
        return 'content.campaigns';
    }
    if (pathname?.includes('/content/posts')) {
        return 'content.posts';
    }
    if (pathname?.includes('/conversations')) {
        return 'conversations';
    }

    return pathname?.replace('/', '').replaceAll('/', '.');
}
